<template>
    <div>
        <div class="d-flex flex-wrap" :class="!is_edit ? '' : ''" v-if="medias && medias.length">
            <div v-for="(item, index) in medias" :key="index" class="mb-1" :class="is_edit ? 'position-relative' : ''">
                <div v-if="isImage(item.name)" class="me-2 thread-medias-img border bd-muted" :style="`background-image: url('${getLinkDownload(item.path)}');`">
                </div>
                <video v-if="isVideo(item.name)" class="me-2 thread-medias-img border bd-muted" controls>
                    <source :src="getLinkDownload(item.path)" :type="item.type">
                    Your browser does not support the video tag.
                </video>
                <a v-if="isFile(item.name)" class="me-2 thread-medias-img border bd-muted" target="_blank" :href="getLinkDownload(item.path)">
                    <p class="mb-0 robo-32-500 txt-pri mx-1"> {{item.name.split('.').pop()}}</p>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import appUtils from '../../utils/appUtils.js'
export default {

  name: 'FileView',
  props: ['medias', 'is_edit'],
  data () {
    return {
      list_medias: null,
      index_media: null
    }
  },
  methods: {
    onShowMedias (medias, index) {
      const self = this
      self.list_medias = medias
      setTimeout(() => {
        self.index_media = index
      }, 100)
    },
    getLinkDownload (link) {
      return appUtils.getDocumentURL(link)
    },
    isImage (name) {
      return name.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null
    },
    isVideo (name) {
      return name.toLowerCase().match(/\.(mp4|ogx|oga|ogv|ogg|webm)$/) != null
    },
    isFile (name) {
      return name.toLowerCase().match(/\.(pdf|docx|doc|xlsx|xls)$/) != null
    },
    getImagesFromEnries (entries) {
      const results = []
      entries.forEach(file => {
        const fileName = file.name.split('.')
        results.push({
          title: file.content,
          src: appUtils.getDocumentURL(file.path),
          type: fileName ? fileName.pop().toLowerCase() : ''
        })
      })
      return results
    }
  }
}
</script>
<style lang="css" scoped>
.thread-medias-img {
    width: auto;
    height: 44px;
    min-width: 44px;
    border-radius: 3px;
    background-size: cover;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
